import React, { useEffect } from "react";
import ReactTooltip from "react-tooltip";
import { isNil } from "ramda";
import { clientProfileEntriesType } from "../../../../../../../prop-types/clientProfileEntryTypes";

import { MONITORING_QUEUE_ENTRY_TYPES } from "../../../../../constants/clientProfileEntryConstants";

import routesConfig from "../../../../../../../routes/routes-config";
import { DocumentIcon, PdfIcon } from "../../../../../../../assets";
import { Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  clientProfilePdfExportIsLoadingSelector,
  clientProfilePdfExportSelector,
} from "../../../../../selectors";
import {
  clearClientProfilePdf,
  exportClientProfilePdf,
} from "../../../../../actions/getActions/getClientProfilePdfActions";
import moment from "moment";

const ProfileDetailsEntriesTableRow = ({ entry }) => {
  const { clientNumber, categoryType, clientName } = entry;
  const dispatch = useDispatch();
  const clientReportPdf = useSelector(clientProfilePdfExportSelector);
  const isLoading = useSelector(clientProfilePdfExportIsLoadingSelector);

  const handleExportPdf = () => {
    dispatch(
      exportClientProfilePdf({ clientNumber, categoryType, clientName })
    );
  };

  useEffect(() => {
    if (clientReportPdf.size > 0) {
      const url = URL.createObjectURL(clientReportPdf);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Client_Profile_${clientNumber}_${moment
        .utc()
        .local()
        .format("DD-MM-YYYY-HHmm")}.pdf`;
      link.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(url);
      }, 100);

      dispatch(clearClientProfilePdf());
    }
  }, [clientReportPdf]);

  return (
    <React.Fragment>
      <tr>
        <td>{categoryType}</td>
        <td>{clientName}</td>
        <td>{clientNumber}</td>
        <td className="center action-buttons ">
          {(entry.clientType ===
            MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH &&
            isNil(entry.clientManualSearchingResult.watchListMatches)) ||
          (entry.clientType ===
            MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH &&
            isNil(entry.clientRegularSearchingResult.watchListMatches)) ? (
            ""
          ) : (
            <a
              target="_blank"
              href={routesConfig.clientProfileDetailsPage.path
                .replace(":clientNumber", entry.clientNumber)
                .replace(":categoryType", entry.categoryType)
                .replace(":clientName", entry.clientName)}
            >
              <ReactTooltip id="details-icon" effect="solid" type="info">
                <span>Generate Report</span>
              </ReactTooltip>
              <span data-tip data-for="details-icon">
                <DocumentIcon />
              </span>
            </a>
          )}
          <Button
            data-tip
            data-for="pdf-icon"
            color="link"
            className="p-0 m-0"
            onClick={handleExportPdf}
            disabled={isLoading}
          >
            <ReactTooltip id="pdf-icon" type="info" effect="solid">
              <span>Export to PDF</span>
            </ReactTooltip>
            <PdfIcon />
          </Button>
        </td>
      </tr>
    </React.Fragment>
  );
};

ProfileDetailsEntriesTableRow.propTypes = {
  entry: clientProfileEntriesType,
};

export default ProfileDetailsEntriesTableRow;



// WEBPACK FOOTER //
// ./src/features/client-profile/components/searching/search-form/table/row/ProfileDetailsEntriesTableRow.jsx